import { GetterTree, MutationTree, Module } from 'vuex';
import { RootState } from '../rootState';
import { Vector2 } from '@babylonjs/core';
import store from '..';
import Element, { ElementType } from '@/models/element';

export enum ProductType {
    CHEST_FURNITURE,
    BED,
    TABLE,
    COFFEE_TABLE,
    BEDSIDE_TABLE,
    DESK,
    COFFEE_TABLE_RECTANGLE,
    DRESSING,
}

export interface Product {
    width: number;
    height: number;
    depth: number;
    shape: Vector2;
    name: string;
    type: ProductType;
    canAddInsides: boolean;
    canAddFronts: boolean;
    cameraPosition: object | null;
    isLevelRaiser: boolean;
    isShelf: boolean;
    canHaveWalls: boolean;
    canHaveBigFronts: boolean;
    haveTop: boolean;
}

const getters: GetterTree<Product, RootState> = {
    product(state): Product { return state; },
    productFullWidth(state): number {
        const result = state.width;
        return Math.ceil(result / 5) * 5;
    },
    productFullHeight(state): number {
        let result = state.height;
        if (store.getters.scene.elements.some((x) =>
            x.type === ElementType.LEGS)) {
            result += store.getters.shaders.selectedLegs.realHeight;
        }
        return Math.ceil(result / 5) * 5;
    },
    productFullDepth(state): number {
        const front = store.getters.scene.elements.find((x: Element) =>
            x.type === ElementType.FRONT,
        );
        let result = state.depth;
        if (front) { result += 16; }
        return Math.ceil(result / 5) * 5;
    },
    isAdvancedOptionsProduct(state): boolean {
        return (
            state.type === ProductType.CHEST_FURNITURE ||
            state.type === ProductType.BEDSIDE_TABLE ||
            state.type === ProductType.DESK ||
            state.type === ProductType.DRESSING
        );
    },
};

const mutations: MutationTree<Product> = {
    setProduct(state, product: any) {
        state.name = product.name;
        state.width = Number(product.width);
        state.height = Number(product.height);
        state.depth = Number(product.depth);
        state.type = product.type;
        state.shape = new Vector2(
            product.shape.x,
            product.shape.y,
        );
    },
};

const currentState: Product = {
    width: 0,
    height: 0,
    depth: 0,
    name: '',
    type: ProductType.CHEST_FURNITURE,
    shape: Vector2.Zero(),
    get canAddInsides(): boolean {
        return (
            this.type === ProductType.CHEST_FURNITURE ||
            this.type === ProductType.DESK ||
            this.type === ProductType.BEDSIDE_TABLE ||
            this.type === ProductType.DRESSING
        );
    },
    get canAddFronts(): boolean {
        return this.type === ProductType.CHEST_FURNITURE;
    },
    cameraPosition: null,
    get isLevelRaiser(): boolean {
        return (
            this.type === ProductType.CHEST_FURNITURE &&
            this.shape.y === 1 &&
            this.depth === 555
        );
    },
    get isShelf(): boolean {
        // todo: temp.
        if (store) {
            return (
                store.getters.configuration.productPreset.code === 'r1x2' ||
                store.getters.configuration.productPreset.code === 'r1x1a'
            );
        }
        else {
            return false;
        }
    },
    get canHaveWalls(): boolean {
        return (
            this.shape.x > 1 ||
            this.shape.y > 1
        );
    },
    get canHaveBigFronts(): boolean {
        return this.type === ProductType.CHEST_FURNITURE;
    },
    get haveTop(): boolean {
        return (
            this.type === ProductType.TABLE ||
            this.type === ProductType.COFFEE_TABLE ||
            this.type === ProductType.COFFEE_TABLE_RECTANGLE ||
            this.type === ProductType.DESK ||
            this.type === ProductType.DRESSING
        );
    },
};

export const ProductModule: Module<Product, RootState> = {
    state: currentState,
    getters,
    mutations,
};
